import { createRoutine } from '@hozana/routines/functions'

import type { TClearIntentionPayload, TEditIntentionPayload, TPostIntentionPaylad } from 'modules/intention/sagas'

export const postIntention = createRoutine<'POST_INTENTION', TPostIntentionPaylad>('POST_INTENTION')
export const editIntention = createRoutine<'EDIT_INTENTION', TEditIntentionPayload>('EDIT_INTENTION')
export const clearIntention = createRoutine<'CLEAR_INTENTION', TClearIntentionPayload>('CLEAR_INTENTION')
